<template>
    <div class="info-container">
        <top-bar></top-bar>
        <nav-bar></nav-bar>
        <right-content></right-content>
    </div>
</template>

<script>
import TopBar from './Manager/TopBar/Index'
import NavBar from './Manager/NavBar/Index'
import RightContent from './Manager/RightContent/Index'
import api from '@/http/api'
import store from '@/store'
import { getAllProvinceList, getProvinceList } from '../http/moudules/base/province'

export default {
    name: 'Home',
    components: {
        TopBar,
        NavBar,
        RightContent
    },
    methods: {
        getProvince(next) {

        },
        // 获取合作方
        getPartners() {
            return new Promise(resolve => {
                api.partners.getAllProvincePartners().then(res => {
                    let obj = res.data
                    const user = JSON.parse(sessionStorage.getItem('user'))
                    if (user && user.partnersId && res.data) {
                        obj = res.data.filter(part => part.partnersId === user.partnersId)
                    }
                    store.commit('getPartnersList', obj)
                    if (user.partnersId && user.provinceId) {
                        store.commit('setPartnersAcquiesce', { partnersId: user.partnersId, provinceId: user.provinceId, provinceName: user.provinceName })
                    }
                    // next(vm => {
                    //     console.log(123)
                    //     vm.$forceUpdate()
                    // })
                    resolve()
                })
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        api.province.getAllProvinceList().then(res => {
            let obj = res.data
            const user = JSON.parse(sessionStorage.getItem('user'))
            if (user && user.provinceId && res.data) {
                obj = res.data.filter(prov => prov.provinceId === user.provinceId)
            }
            store.commit('getProvinceList', obj)
            if (user.provinceId && user.provinceName) {
                store.commit('setAcquiesce', { provinceId: user.provinceId, provinceName: user.provinceName })
            }
            api.partners.getAllProvincePartners().then(res => {
                let obj = res.data
                const user = JSON.parse(sessionStorage.getItem('user'))
                if (user && user.partnersId && res.data) {
                    obj = res.data.filter(part => part.partnersId === user.partnersId)
                }
                store.commit('getPartnersList', obj)
                if (user.partnersId && user.provinceId) {
                    store.commit('setPartnersAcquiesce', { partnersId: user.partnersId, provinceId: user.provinceId, provinceName: user.provinceName })
                }
                next()
            })
        })
    },
    mounted() {

    }
}
</script>

<style scoped>
  .info-container{
    background-color: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue